import { useAppContext } from "./useAppContext";
import { useState } from "react";
import { plagiarism, type PlagiarismRequestData } from "../services/plagiarism";
import { handleErrorMessage } from "../lib/utils";

export function usePlagiarism() {
	const [isLoading, setIsLoading] = useState(false);
	const { setPlagiarismResult } = useAppContext();

	const checkPlagiarism = async (data: PlagiarismRequestData) => {
		if (!data.text.trim()) {
			return;
		}

		setIsLoading(true);

		return plagiarism(data) //TODO: set country *The country code of the country where the text was written. Default: us.
			.then(setPlagiarismResult)
			.catch((error) => {
				handleErrorMessage(error, "Error checking plagiarism");
				throw error;
			})
			.finally(() => setIsLoading(false));
	};

	return { checkPlagiarism, isLoading };
}
